import { CanMatchFn, Route } from '@angular/router';
import { PermissionsService } from '../permissions/permissions.service';
import { inject } from '@angular/core';

export const permissionGuard: CanMatchFn = (route: Route) => {
  const authService = inject(PermissionsService);
  const hasRight = route.data?.routeItem.hasRight;
  if (!hasRight) {
    console.error(
      'Provide the hasRight configuration in the app routes. You cannot use the permissionGuard without the hasRight configuration.'
    );
  }
  return authService.hasRight(hasRight.resourceValue, hasRight.targetPermissionValue);
};
